// src/components/AdminPanel.js
import React, { useState, useEffect } from "react";
import { fetchData, updateData } from "../services/api";
import { DangTai } from "../vo";

const CAC_QUYEN = [
  { ma: "view", nhan: "Xem" },
  { ma: "add", nhan: "Thêm" },
  { ma: "edit", nhan: "Sửa" },
  { ma: "delete", nhan: "Xóa" },
];

// ============================================================
// 🔑 QUYỀN RIÊNG CHO TỪNG MỤC
// ------------------------------------------------------------
// Bốn ô ở trên (`family`) áp cho MỌI mục chung: Lịch · Việc nhà · Đi chợ
// · Danh bạ · Mẹo vặt · Sân chơi. Sáu mục đó cùng một luật nên dùng chung
// một bộ ô là đúng.
//
// Danh sách dưới đây là những mục có luật RIÊNG. Hiện đúng một mục.
//
// Vì sao phải có: chân dung 4.3 nói "chỉ Ba Mẹ đăng, các con chỉ đọc" cho
// Báo chi tiêu. Với bảng cũ, muốn chặn các con sửa bản tin chi tiêu thì
// phải bỏ tick ô "Sửa" — và thế là chúng mất luôn quyền sửa ở Việc nhà,
// Đi chợ, Danh bạ. Chủ nhà gặp đúng chuyện đó ngày 07/09/2026.
//
// ⚠️ CỐ Ý KHÔNG LÀM MA TRẬN TỪNG MỤC. Đã rà cả bảy mục: chỉ Báo chi tiêu
// khác luật. Ma trận đầy đủ là 7 × 4 = 28 ô cho mỗi người, mà sáu trên
// bảy hàng giống hệt nhau. Khi nào có ngoại lệ THỨ HAI thì thêm một dòng
// vào mảng này — mọc từng ô theo nhu cầu có thật rẻ hơn dựng sẵn một
// bảng mà 90% ô không ai dùng.
// ============================================================
const QUYEN_RIENG = [
  {
    module: "chi_tieu",
    ma: "soan",
    nhan: "💰 Chi tiêu",
    chuThich: "Được soạn bản tin chi tiêu (tạo · sửa · xóa)",
  },
  // Ngoại lệ THỨ HAI — thêm ở Đợt N2, 08/09/2026, đúng như khối ghi chú
  // bên trên đã liệu trước: *"khi nào có ngoại lệ THỨ HAI thì thêm một dòng
  // vào mảng này."*
  //
  // ⚠️ Ý nghĩa ô này đã ĐỔI chiều 08/09/2026. Ban đầu nó là "được đăng mục
  // cho cả nhà". Chủ nhà bác bỏ: *"đây là đuổi tụi nó khỏi xài app."*
  // Nay ai cũng đăng được; ô này chỉ còn nghĩa "được DỌN mục chung của
  // người khác" — giữ lại vì xóa nhầm giỗ ông nội thì không lấy lại được.
  // Không dùng được `family.edit` vì cắt nó là các con mất luôn quyền sửa ở
  // Việc nhà, Đi chợ, Danh bạ — đúng cái bẫy đã gặp với Chi tiêu hôm 07/09.
  //
  // Mục RIÊNG của từng người không dinh dáng gì tới ô này: ai cũng toàn
  // quyền với lịch của mình.
  {
    module: "lich",
    ma: "soan",
    nhan: "📅 Dọn lịch chung",
    chuThich:
      "Được sửa/xóa mục chung do NGƯỜI KHÁC đăng. Ai cũng đăng được mục cho cả nhà và tự sửa mục của mình — ô này chỉ để dọn giúp.",
  },
];

function AdminPanel() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  // Đang đặt lại mật khẩu cho ai (null = không ai)
  const [dangDatMK, setDangDatMK] = useState(null);
  const [mkMoi, setMkMoi] = useState("");
  const [dangLuuMK, setDangLuuMK] = useState(false);

  // Đang sửa tên hiển thị của ai (null = không ai)
  const [dangSuaTen, setDangSuaTen] = useState(null);
  const [tenMoi, setTenMoi] = useState("");
  const [dangLuuTen, setDangLuuTen] = useState(false);

  const loadUsers = async () => {
    try {
      const data = await fetchData("admin/users");
      setUsers(data);
    } catch (err) {
      setMessage("⚠️ Lỗi tải danh sách thành viên");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const bao = (chu, giay = 2500) => {
    setMessage(chu);
    setTimeout(() => setMessage(""), giay);
  };

  const togglePermission = async (userId, module, action) => {
    const nguoi = users.find((u) => u.id === userId);
    if (!nguoi) return;

    // Sao chép SÂU trước khi sửa.
    // Trước đây đoạn này lấy thẳng tham chiếu tới user.permissions rồi sửa lên
    // đó — tức là sửa trực tiếp vào state của React. React không nhận ra dữ liệu
    // đã đổi nên có lúc không vẽ lại, làm ô tick "nhảy" hoặc không đổi.
    const perms = JSON.parse(JSON.stringify(nguoi.permissions || {}));
    if (!perms[module]) perms[module] = {};
    perms[module][action] = !perms[module][action];

    try {
      await updateData("admin/users", `${userId}/permissions`, {
        permissions: perms,
      });
      setUsers(users.map((u) => (u.id === userId ? { ...u, permissions: perms } : u)));
      bao("✅ Đã cập nhật quyền — có hiệu lực ngay");
    } catch (err) {
      bao("⚠️ Lỗi cập nhật quyền");
    }
  };

  // ⚠️ Đây là TÊN HIỂN THỊ, không phải tên đăng nhập.
  // Đổi cái này chỉ đổi cái tên cả nhà nhìn thấy. `username` giữ nguyên —
  // đổi username là người ta không đăng nhập được nữa, nên app cố ý không
  // cho đổi nó ở đâu cả.
  const luuTen = async (userId) => {
    const ten = tenMoi.trim();
    if (ten === "") {
      bao("⚠️ Tên hiển thị không được để trống");
      return;
    }
    setDangLuuTen(true);
    try {
      await updateData("admin/users", `${userId}/ten`, { full_name: ten });
      setUsers(users.map((u) => (u.id === userId ? { ...u, full_name: ten } : u)));
      setDangSuaTen(null);
      setTenMoi("");
      // Dòng chào ở đầu trang lấy tên từ bản đã lưu trong trình duyệt, nên nó
      // chưa đổi ngay. Nói thẳng ra thay vì để người dùng tưởng là chưa lưu.
      bao(`✅ Đã đổi tên thành "${ten}" — tải lại trang để dòng chào cập nhật`, 5000);
    } catch (err) {
      bao("⚠️ Không đổi được tên hiển thị");
    } finally {
      setDangLuuTen(false);
    }
  };

  const datLaiMatKhau = async (userId) => {
    if (mkMoi.length < 6) {
      bao("⚠️ Mật khẩu mới phải có ít nhất 6 ký tự");
      return;
    }
    setDangLuuMK(true);
    try {
      await updateData("admin/users", `${userId}/password`, {
        newPassword: mkMoi,
      });
      const nguoi = users.find((u) => u.id === userId);
      bao(`✅ Đã đặt mật khẩu mới cho ${nguoi ? nguoi.full_name : "thành viên"}`, 4000);
      setDangDatMK(null);
      setMkMoi("");
    } catch (err) {
      bao("⚠️ Không đặt lại được mật khẩu");
    } finally {
      setDangLuuMK(false);
    }
  };

  if (loading) return <DangTai gi="danh sách thành viên" />;

  return (
    <div className="card" style={{ marginBottom: "20px" }}>
      <h3>👥 Quản lý thành viên</h3>
      {message && <div className="notification">{message}</div>}

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#f1f5f9" }}>
            <th style={{ padding: "8px", textAlign: "left" }}>Tên</th>
            {CAC_QUYEN.map((q) => (
              <th key={q.ma} style={{ padding: "8px", textAlign: "center" }}>
                {q.nhan}
              </th>
            ))}
            {QUYEN_RIENG.map((q) => (
              <th key={q.ma} style={{ padding: "8px", textAlign: "center" }} title={q.chuThich}>
                {q.nhan}
              </th>
            ))}
            <th style={{ padding: "8px", textAlign: "center" }}>Mật khẩu</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <React.Fragment key={user.id}>
              <tr style={{ borderBottom: "1px solid #e9edf2" }}>
                <td style={{ padding: "8px" }}>
                  {user.full_name} ({user.username})
                  <button
                    onClick={() => {
                      setDangSuaTen(dangSuaTen === user.id ? null : user.id);
                      setTenMoi(user.full_name || "");
                    }}
                    title="Đổi tên hiển thị"
                    style={{
                      marginLeft: 6,
                      padding: "2px 6px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: 13,
                    }}
                  >
                    ✏️
                  </button>
                  {user.role === "admin" && (
                    <span style={{ marginLeft: 6, fontSize: 12, color: "#64748b" }}>
                      — quản trị, luôn có mọi quyền
                    </span>
                  )}
                </td>

                {CAC_QUYEN.map((q) => (
                  <td key={q.ma} style={{ padding: "8px", textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={
                        user.role === "admin" ||
                        user.permissions?.family?.[q.ma] === true
                      }
                      onChange={() => togglePermission(user.id, "family", q.ma)}
                      disabled={user.role === "admin"}
                    />
                  </td>
                ))}

                {QUYEN_RIENG.map((q) => (
                  <td key={q.ma} style={{ padding: "8px", textAlign: "center" }} title={q.chuThich}>
                    <input
                      type="checkbox"
                      checked={
                        user.role === "admin" ||
                        user.permissions?.[q.module]?.[q.ma] === true
                      }
                      onChange={() => togglePermission(user.id, q.module, q.ma)}
                      disabled={user.role === "admin"}
                    />
                  </td>
                ))}

                <td style={{ padding: "8px", textAlign: "center" }}>
                  <button
                    onClick={() => {
                      setDangDatMK(dangDatMK === user.id ? null : user.id);
                      setMkMoi("");
                    }}
                    style={{
                      padding: "4px 10px",
                      background: dangDatMK === user.id ? "#64748b" : "#f59e0b",
                      color: "#fff",
                      border: "none",
                      borderRadius: 6,
                      cursor: "pointer",
                      fontSize: 13,
                    }}
                  >
                    {dangDatMK === user.id ? "Đóng" : "🔑 Đặt lại"}
                  </button>
                </td>
              </tr>

              {dangSuaTen === user.id && (
                <tr>
                  <td colSpan={CAC_QUYEN.length + QUYEN_RIENG.length + 2} style={{ padding: "10px 8px", background: "#eff6ff" }}>
                    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                      <span style={{ fontSize: 14 }}>Tên hiển thị mới:</span>
                      <input
                        type="text"
                        value={tenMoi}
                        onChange={(e) => setTenMoi(e.target.value)}
                        placeholder="Ba, Mẹ, Con Trai…"
                        maxLength={60}
                        autoFocus
                        style={{
                          padding: "6px 10px",
                          border: "1px solid #d1d5db",
                          borderRadius: 6,
                          fontSize: 16,
                          minWidth: 200,
                        }}
                      />
                      <button
                        onClick={() => luuTen(user.id)}
                        disabled={dangLuuTen}
                        style={{
                          padding: "6px 14px",
                          background: dangLuuTen ? "#94a3b8" : "#16a34a",
                          color: "#fff",
                          border: "none",
                          borderRadius: 6,
                          cursor: dangLuuTen ? "not-allowed" : "pointer",
                          fontSize: 14,
                        }}
                      >
                        {dangLuuTen ? "Đang lưu..." : "Lưu tên"}
                      </button>
                      <span style={{ fontSize: 13, color: "#1e40af" }}>
                        Chỉ đổi tên cả nhà nhìn thấy. Tên đăng nhập ({user.username}) giữ nguyên.
                      </span>
                    </div>
                  </td>
                </tr>
              )}

              {dangDatMK === user.id && (
                <tr>
                  <td colSpan={CAC_QUYEN.length + QUYEN_RIENG.length + 2} style={{ padding: "10px 8px", background: "#fffbeb" }}>
                    <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                      <span style={{ fontSize: 14 }}>
                        Mật khẩu mới cho <strong>{user.full_name}</strong>:
                      </span>
                      <input
                        type="text"
                        value={mkMoi}
                        onChange={(e) => setMkMoi(e.target.value)}
                        placeholder="ít nhất 6 ký tự"
                        style={{
                          padding: "6px 10px",
                          border: "1px solid #d1d5db",
                          borderRadius: 6,
                          fontSize: 14,
                          minWidth: 200,
                        }}
                      />
                      <button
                        onClick={() => datLaiMatKhau(user.id)}
                        disabled={dangLuuMK}
                        style={{
                          padding: "6px 14px",
                          background: dangLuuMK ? "#94a3b8" : "#16a34a",
                          color: "#fff",
                          border: "none",
                          borderRadius: 6,
                          cursor: dangLuuMK ? "not-allowed" : "pointer",
                          fontSize: 14,
                        }}
                      >
                        {dangLuuMK ? "Đang lưu..." : "Lưu mật khẩu"}
                      </button>
                      <span style={{ fontSize: 13, color: "#92400e" }}>
                        Mật khẩu hiện rõ để bạn đọc cho thành viên — nhớ báo họ đổi lại.
                      </span>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminPanel;
